import React from "react";

export function ResumeDocument({ children, className = "", style = {}, ...props }) {
  return (
    <div
      className={["cv-document", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

export function ResumePage({ children, className = "", style = {}, ...props }) {
  return (
    <div
      className={["page", "cv-page", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

export function ResumeHeader({ children, className = "", style = {}, ...props }) {
  return (
    <header
      className={["cv-header", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </header>
  );
}

export function ResumeMain({ children, className = "", style = {}, ...props }) {
  return (
    <main
      className={["cv-main", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </main>
  );
}

export function ResumeSidebar({ children, className = "", style = {}, ...props }) {
  return (
    <aside
      className={["cv-sidebar", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </aside>
  );
}

export function ResumeSection({
  children,
  className = "",
  style = {},
  sectionId,
  keep = "auto",
  flow,
  title,
  ...props
}) {
  return (
    <section
      className={["cv-section", className].filter(Boolean).join(" ")}
      data-cv-section="true"
      data-cv-kind={sectionId}
      data-cv-keep={keep !== "auto" ? keep : undefined}
      data-cv-flow={flow}
      data-section={props["data-section"] || sectionId}
      style={style}
      {...props}
    >
      {title}
      {children}
    </section>
  );
}

export function ResumeItem({
  children,
  className = "",
  style = {},
  itemKind,
  as: Component = "article",
  ...props
}) {
  return (
    <Component
      className={["cv-group", className].filter(Boolean).join(" ")}
      data-cv-group="true"
      data-cv-kind={itemKind}
      style={style}
      {...props}
    >
      {children}
    </Component>
  );
}

export function ResumeMetaRow({ children, className = "", style = {}, ...props }) {
  return (
    <div
      className={["cv-meta-row", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

export function ResumeTextBlock({ children, className = "", style = {}, ...props }) {
  return (
    <div
      className={["cv-text-block", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

export function ResumeList({ children, className = "", style = {}, as: Component = "div", ...props }) {
  return (
    <Component
      className={["cv-list", className].filter(Boolean).join(" ")}
      style={style}
      {...props}
    >
      {children}
    </Component>
  );
}
